import { createContext, useEffect, useContext, useState } from "react";

import { useRouter } from "next/router";
import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.node,
};

const StudentPreviewContext = createContext();

export const StudentPreviewContextProvider = ({ children }) => {
  const router = useRouter();
  const { query } = router;
  const { studentPreview } = query;

  const [isStudentPreviewOn, setIsStudentPreviewOn] = useState(false);

  // The state of the current assignment's level lock will help determine how the
  // level selector will look like in the student preview. We store it in state
  // because it is subject to change if the assignment is updated.
  const [
    isAssignmentLevelLockedForStudentPreview,
    setIsAssignmentLevelLockedForStudentPreview,
  ] = useState();

  useEffect(() => {
    // Ensure the button is toggled when loading the page with the studentPreview param.
    if (studentPreview === "true") {
      setIsStudentPreviewOn(true);
    }
  }, [studentPreview]);

  return (
    <StudentPreviewContext.Provider
      value={{
        isAssignmentLevelLockedForStudentPreview,
        isStudentPreviewOn,
        setIsAssignmentLevelLockedForStudentPreview,
        setIsStudentPreviewOn,
      }}
    >
      {children}
    </StudentPreviewContext.Provider>
  );
};

StudentPreviewContextProvider.propTypes = propTypes;

const useStudentPreviewContext = () => {
  const studentPreviewContext = useContext(StudentPreviewContext);

  if (studentPreviewContext === undefined) {
    throw new Error(
      "studentPreviewContext must be used within a StudentPreviewContextProvider.",
    );
  }

  return studentPreviewContext;
};

export default useStudentPreviewContext;
